// components
// import { BookingCouponCard } from "components/OldBooking/BookingWeb/BookingCouponCard";
import ListingCouponCard from "./ListingCouponCard";

// assets
import { SvgClose } from "assets/icons/js/SvgClose";
import { SvgNavigationArrow } from "assets/icons/js/SvgNavigationArrow";

// customHooks
import { useMediaQuery } from "customHooks/useMediaQuery";

// style
import "./style.scss";

export const ListingCoupon = ({
	closeModal,
	fetchCouponsListings,
	checkin,
	checkout,
}: any) => {
	const width = useMediaQuery();

	const isMobile = width < 900 ? true : false;

	return (
		<div className="booking__coupon-listing">
			<div className="booking__coupon-listing-container">
				<div className="booking__coupon-listing-top">
					<div className="coupon-top">
						<span onClick={closeModal}>
							{isMobile && <SvgNavigationArrow />}
						</span>
						{!isMobile && <p>Coupons & Offers</p>}
						<span onClick={closeModal}>{!isMobile && <SvgClose />}</span>
					</div>
				</div>
				<div className="booking__coupon-content">
					{fetchCouponsListings?.data?.data?.data &&
					fetchCouponsListings?.data?.data?.data.filter(
						(v: any) => v.isApplicable,
					).length > 0 ? (
						<>
							<div className="booking__coupon-middle">
								<p>Available Coupons</p>
							</div>
							<div className="booking__coupon-bottom">
								<div className="booking__coupon-listing-card">
									{fetchCouponsListings?.data?.data?.data &&
										fetchCouponsListings?.data?.data?.data.length > 0 &&
										fetchCouponsListings?.data?.data?.data?.map((item: any) =>
											item?.isApplicable ? (
												<ListingCouponCard item={item} />
											) : null,
										)}
								</div>
							</div>
						</>
					) : null}
					<div className="booking__coupon-middle">
						<p>Unavailable Coupons</p>
					</div>
					<div className="booking__coupon-bottom">
						<div className="booking__coupon-listing-card">
							{fetchCouponsListings?.data?.data?.data &&
								fetchCouponsListings?.data?.data?.data.length > 0 &&
								fetchCouponsListings?.data?.data?.data?.map((item: any) =>
									!item?.isApplicable ? (
										<ListingCouponCard
											item={item}
											checkin={checkin}
											checkout={checkout}
										/>
									) : null,
								)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
